export default "__VITE_ASSET__BHhE$eOo__"